//variable para el mantenimiento de la app
export const enMantenimiento = false;

// Rutas que siguen en el código pero se ocultan en producción.
// En dev (next dev) funcionan normal; en el build de producción devuelven 404.
export const ocultarEnProduccion = process.env.NODE_ENV === "production";

// Dominio público del sitio. Detrás del proxy de producción (IIS/ARR) Next no
// ve este host sino el interno, así que las URLs absolutas salen de aquí.
export const ORIGEN_PUBLICO =
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.tocumenaero.com";

// ---------------------------------------------------------------------------
// Campaña de votación en la encuesta de Skytrax (World Airport Awards).
// Editable a mano: al pasar `hasta` la banda del header y la entrada del
// drawer desaparecen solas, sin tocar el espaciado de ninguna página. Para
// retirarla antes de tiempo basta con adelantar la fecha o poner `activa: false`.
// ---------------------------------------------------------------------------
export const CAMPANA_SKYTRAX = {
  activa: false,
  // Último día en que se muestra, inclusive (AAAA-MM-DD, hora de Panamá).
  hasta: "2026-12-01",
  url: "https://www.worldairportsurvey.com/Surveys/ES_Airport/best_airport.html",
} as const;

/**
 * Se evalúa en el cliente, nunca en el render del servidor: el build
 * congelaría el resultado de comparar contra la fecha de compilación y la
 * banda seguiría viva (o muerta) hasta el siguiente despliegue.
 */
export function campanaSkytraxVigente(ahora: Date = new Date()) {
  if (!CAMPANA_SKYTRAX.activa) return false;
  // `hasta` es inclusive, así que el corte es el final de ese día.
  return ahora.getTime() < Date.parse(`${CAMPANA_SKYTRAX.hasta}T23:59:59`);
}
